/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
import { M as Modal, d as defineCustomElement$1 } from './p-iyo0Toaz.js';

const IonModal = Modal;
const defineCustomElement = defineCustomElement$1;

export { IonModal, defineCustomElement };
